import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { ContractTypeService } from '../proxy/controlling/controllers/contract-type.service';
import { SapDocumentTypeService } from '../proxy/controlling/controllers/sap-document-type.service';
import { CostCenterService } from '../proxy/controlling/controllers/cost-center.service';
import { ProfitCenterService } from '../proxy/controlling/controllers/profit-center.service';
import { InternalOrderService } from '../proxy/controlling/controllers/internal-order.service';
import { WbsService } from '../proxy/controlling/controllers/wbs.service';
import { AccountService } from '../proxy/controlling/controllers/account.service';
import { SapAmountTypeService } from '../proxy/controlling/controllers/sap-amount-type.service';
FieldBuilder.setNamespace('Controlling');

export const SAPFICOPARAMETER_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('contractTypeId', 'Entity.ContractType', ContractTypeService)
    .displayFromNested('contractType.name')
    .sortBy('contractType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('documentTypeId', 'Entity.SapDocumentType', SapDocumentTypeService)
    .displayFromNested('sapDocumentType.name')
    .sortBy('sapDocumentType.name')
    .build(),
  FieldBuilder.checkbox('hasCostCenter', 'Entity.SapFicoParameter.HasCostCenter')
    .build(),
  FieldBuilder.foreignKey('costCenterId', 'Entity.CostCenter', CostCenterService)
    .displayFromNested('costCenter.sapCode')
    .sortBy('costCenter.sapCode')
    .build(),
  FieldBuilder.checkbox('hasProfitCenter', 'Entity.SapFicoParameter.HasProfitCenter')
    .build(),
  FieldBuilder.foreignKey('profitCenterId', 'Entity.ProfitCenter', ProfitCenterService)
    .displayFromNested('profitCenter.sapCode')
    .sortBy('profitCenter.sapCode')
    .build(),
  FieldBuilder.checkbox('hasInternalOrder', 'Entity.SapFicoParameter.HasInternalOrder')
    .build(),
  FieldBuilder.foreignKey('internalOrderId', 'Entity.InternalOrder', InternalOrderService)
    .displayFromNested('internalOrder.name')
    .sortBy('internalOrder.name')
    .build(),
  FieldBuilder.checkbox('hasWbs', 'Entity.SapFicoParameter.HasWbs')
    .build(),
  FieldBuilder.foreignKey('wbsId', 'Entity.Wbs', WbsService)
    .displayFromNested('wbs.name')
    .sortBy('wbs.name')
    .build(),
  FieldBuilder.checkbox('hasAccount', 'Entity.SapFicoParameter.HasAccount')
    .build(),
  FieldBuilder.foreignKey('accountId', 'Entity.Account', AccountService)
    .displayFromNested('account.name')
    .sortBy('account.name')
    .build(),
  FieldBuilder.checkbox('hasAssignment', 'Entity.SapFicoParameter.HasAssignment')
    .build(),
  FieldBuilder.checkbox('isHeaderInformation', 'Entity.SapFicoParameter.IsHeaderInformation')
    .build(),
  FieldBuilder.checkbox('isPositiveAmount', 'Entity.SapFicoParameter.IsPositiveAmount')
    .build(),
  FieldBuilder.foreignKey('amountTypeId', 'Entity.SapAmountType', SapAmountTypeService)
    .displayFromNested('sapAmountType.name')
    .sortBy('sapAmountType.name')
    .build(),
  FieldBuilder.checkbox('hasQuantity', 'Entity.SapFicoParameter.HasQuantity')
    .build(),
  FieldBuilder.text('sglIndicator', 'Entity.SapFicoParameter.SglIndicator')
    .build(),
];

export const SAPFICOPARAMETER_CONFIG = {
  entityName: 'SapFicoParameter',
  localizationKey: 'Controlling::Entity.SapFicoParameter',
  fields: SAPFICOPARAMETER_FIELDS,
  permission: 'ControllingSap.SapFicoParameters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
